import styles from '@/app/[locale]/products/[slug]/components/CondensedProductCard/CondensedProductCard.module.css';
import { getLargestProductPictureFormat } from '@/modules/pictures/helpers/getLargestProductPictureFormat';
import { toProductPicture } from '@/modules/product/helpers/toProductMedia';
import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';

export function useCarouselImages() {
  const { data: productBasic } = useProductBySlugBasicPDP();
  const allPictures = productBasic?.pictures || [];
  const className = styles.mainImage;

  return allPictures
    .map((pic, i) => {
      const url = pic.formats
        ? getLargestProductPictureFormat(toProductPicture(pic).formats).url
        : '';
      return url ? (
        <img
          key={pic.id || i}
          className={className}
          src={url}
          alt={i === 0 ? productBasic?.description || '' : ''}
        />
      ) : null;
    })
    .filter(Boolean);
}
